<template>
  <div>
    <!-- input Recherche -->
    <div class="custom-search d-flex justify-content-start">
      <b-form-group>
        <b-form-group
          v-if="user.role === 'admin'"
          label="Suivi des dépôts"
        >
          <validation-provider
            #default="{ errors }"
            name="Depot"
          >
            <v-select
              v-model="repository"
              :clearable="false"
              placeholder="Depots"
              label="name"
              :options="repositories"
              @input="getOrders(1)"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <!-- Status buttons removed since we're showing all orders by default -->
      </b-form-group>
    </div>
    <b-row>
      <b-col md="2">
        <b-form-group
          label="Bordereau"
          label-for="bl"
        >
          <div class="d-flex align-items-center">
            <b-form-input
              v-model="bl"
              v-debounce:1000="findById"
              placeholder="Recherche"
              type="text"
              class="d-inline-block"
            />
          </div>
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group
          label="Nom"
          label-for="Name"
        >
          <div class="d-flex align-items-center">
            <b-form-input
              v-model="name"
              v-debounce:1000="findByName"
              placeholder="Entrer  le nom du client"
              type="text"
              class="d-inline-block"
            />
          </div>
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group
          label="Téléphone"
          label-for="Téléphone"
        >
          <div class="d-flex align-items-center">
            <b-form-input
              v-model="phone"
              v-debounce:1000="findByPhone"
              placeholder="Téléphone"
              type="text"
              class="d-inline-block"
            />
          </div>
        </b-form-group>
      </b-col>
      <b-col
        md="3"
        class="d-flex align-items-center justify-content-between"
      >
        <b-form-group
          label="Gouvernoart"
          label-for="gouvernoart"
          class="flex-grow-1"
        >
          <v-select
            v-model="governorate"
            :clearable="false"
            placeholder="gouvernorats"
            label="name"
            :options="governorates"
            @input="findByGovernorate()"
          />
        </b-form-group>
        <feather-icon
          id="governorat"
          class="mt-1 ml-1"
          variant="primary"
          icon="XSquareIcon"
          size="20"
          @click="clearGovernorate()"
        />

        <b-tooltip
          title="Annuler filtrage par gouvernorat"
          class="cursor-pointer"
          target="governorat"
        />
      </b-col>
      <b-col
        v-if="user.role === 'admin' || user.role === 'manager'"
        md="3"
        class="d-flex align-items-center justify-content-between"
      >
        <b-form-group
          label="Fournisseur"
          label-for="Fournisseur"
          class="flex-grow-1"
        >
          <v-select
            v-model="supplier1"
            :clearable="false"
            placeholder="fournisseur"
            label="username"
            :options="filteredSuppliers"
            @input="findBySupplier(1)"
          />
        </b-form-group>
        <feather-icon
          id="supplier"
          class="mt-1 ml-1"
          variant="primary"
          icon="XSquareIcon"
          size="20"
          @click="clearSupplier()"
        />

        <b-tooltip
          title="Annuler filtrage par fournisseur"
          class="cursor-pointer"
          target="supplier"
        />
      </b-col>
      <b-col
        md="2"
        class="d-flex align-items-center justify-content-between"
      >
        <b-form-group
          label="Type"
          label-for="exchange-filter"
          class="flex-grow-1"
        >
          <v-select
            v-model="isExchange"
            :clearable="true"
            placeholder="Échange"
            label="label"
            :options="exchangeOptions"
            @input="filterByExchange()"
          />
        </b-form-group>
        <feather-icon
          id="exchange-clear"
          class="mt-1 ml-1"
          variant="primary"
          icon="XSquareIcon"
          size="20"
          @click="clearExchange()"
        />
        <b-tooltip
          title="Annuler filtrage par type d'échange"
          class="cursor-pointer"
          target="exchange-clear"
        />
      </b-col>
      <b-col
        md="2"
        class="d-flex align-items-center justify-content-between"
      >
        <b-form-group
          label="Fragile"
          label-for="fragile-filter"
          class="flex-grow-1"
        >
          <v-select
            v-model="isFragile"
            :clearable="true"
            placeholder="Fragile"
            label="label"
            :options="fragileOptions"
            @input="filterByFragile()"
          />
        </b-form-group>
        <feather-icon
          id="fragile-clear"
          class="mt-1 ml-1"
          variant="primary"
          icon="XSquareIcon"
          size="20"
          @click="clearFragile()"
        />
        <b-tooltip
          title="Annuler filtrage par fragilité"
          class="cursor-pointer"
          target="fragile-clear"
        />
      </b-col>
      <b-col
        v-if="user.role === 'admin'"
        md="2"
        class="d-flex align-items-center justify-content-between"
      >
        <b-form-group
          label="Synchronisé"
          label-for="sync-filter"
          class="flex-grow-1"
        >
          <v-select
            v-model="isSynchronized"
            :clearable="true"
            placeholder="Sync"
            label="label"
            :options="syncOptions"
            @input="getOrders(1)"
          />
        </b-form-group>
        <feather-icon
          id="sync-clear"
          class="mt-1 ml-1"
          variant="primary"
          icon="XSquareIcon"
          size="20"
          @click="clearSynchronized()"
        />
        <b-tooltip
          title="Annuler filtrage par synchronisation"
          class="cursor-pointer"
          target="sync-clear"
        />
      </b-col>

      <b-col
        v-if="user.role === 'admin'"
        md="3"
        class="d-flex align-items-center justify-content-between"
      >
        <b-form-group
          label="Outsourcing"
          label-for="outsourcing-filter"
          class="flex-grow-1"
        >
          <v-select
            v-model="outsourcingCompany"
            :clearable="true"
            placeholder="Outsourcing"
            label="name"
            :options="outsourcingCompanies"
            @input="getOrders(1)"
          />
        </b-form-group>
        <feather-icon
          id="outsourcing-clear"
          class="mt-1 ml-1"
          variant="primary"
          icon="XSquareIcon"
          size="20"
          @click="clearOutsourcingCompany()"
        />
        <b-tooltip
          title="Annuler filtrage par société d'outsourcing"
          class="cursor-pointer"
          target="outsourcing-clear"
        />
      </b-col>
      <b-col
        md="2"
        class="mt-1"
      >
        <b-form-group v-if="user.role === 'supplier'">
          <b-button
            :to="{ name: 'order-add' }"
            variant="gradient-primary"
            class="ml-1 d-inline-block"
          >
            <feather-icon icon="PlusIcon" />
            <span class="ml-1">Ajouter colis</span>
          </b-button>
        </b-form-group>
      </b-col>
    </b-row>
    <div
      v-if="isLoading === true"
      class="text-center mb-2"
    >
      <b-spinner
        variant="primary"
        label="Text Centered"
      />
    </div>
    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="orders"
      :current-page="currentPage"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >
        <div
          v-if="props.column.field === 'id'"
          class="text-nowrap d-flex flex-column align-items-start"
        >
          <qrcode-vue
            style="display:inline"
            :value="props.row.id.toString()"
            :size="size"
            level="H"
          />
          <div class="mt-1">
            {{ props.row.id }}
          </div>
          <div
            v-if="props.row.is_an_exchange"
            class="text-primary mt-1 small font-italic d-flex align-items-center"
          >
            Échange
            <feather-icon
              icon="RefreshCwIcon"
              size="15"
              class="ml-1"
            />
          </div>
          <div
            v-if="props.row.is_fragile"
            class="text-warning mt-1 small font-italic d-flex align-items-center"
          >
            Fragile
            <feather-icon
              icon="AlertTriangleIcon"
              size="15"
              class="ml-1"
            />
          </div>
        </div>
        <span v-if="props.column.field === 'status'">
          <div v-if="props.row.status === 0">
            <b-badge
              class="badge-glow bg-warning bg-lighten-1"
              pill
            >
              <feather-icon
                icon="XIcon"
                class="mr-25"
              />
              <span> En attente</span>
            </b-badge>
          </div>
          <div v-if="props.row.status === 1">
            <b-badge
              class="badge-glow bg-warning bg-darken-2"
              pill
            >
              <feather-icon
                icon="CheckIcon"
                class="mr-25"
              />
              <span> En Pickup</span>
            </b-badge>
          </div>
          <div v-if="props.row.status === 2">
            <b-badge
              class="badge-glow bg-info bg-lighten-1"
              pill
            >
              <feather-icon
                icon="CheckIcon"
                class="mr-25"
              />
              <span> Au dépôt</span>
            </b-badge>
          </div>
          <div v-if="props.row.status === 3">
            <b-badge
              class="badge-glow bg-info bg-darken-2"
              pill
              variant="success"
            >
              <feather-icon
                icon="CheckIcon"
                class="mr-25"
              />
              <span> En cours</span>
            </b-badge>
          </div>
          <div v-if="props.row.status === 4">
            <b-badge
              class="badge-glow bg-success bg-lighten-2"
              pill
            >
              <feather-icon
                icon="CheckIcon"
                class="mr-25"
              />
              <span> Livré </span>
            </b-badge>
          </div>
          <div v-if="props.row.status === 5">
            <b-badge
              class="badge-glow bg-danger bg-lighten-2"
              pill
            >
              <feather-icon
                icon="XIcon"
                class="mr-25"
              />
              <span> Retour Au dépôt </span>
            </b-badge>
          </div>
          <div v-if="props.row.status === 8">
            <b-badge
              class="badge-glow bg-secondary bg-lighten-2"
              pill
            >
              <feather-icon
                icon="XIcon"
                class="mr-25"
              />
              <span> Transfert </span>
            </b-badge>
          </div>
          <div
            v-if="props.row.status === 7"
          >
            <b-badge
              class="
            badge-glow"
              pill
              variant="danger"
            >
              <feather-icon
                icon="XIcon"
                class="mr-25"
              />
              <span> Retour au fournisseur </span>
            </b-badge>
          </div>
          <div
            v-if="props.row.status === 6"
          >
            <b-badge
              class="
            badge-glow"
              pill
              variant="success"
            >
              <feather-icon
                icon="CheckIcon"
                class="mr-25"
              />
              <span> Livré payé </span>
            </b-badge>
          </div>
          <div
            v-if="props.row.status === 9"
          >
            <b-badge
              class="
            badge-glow"
              pill
              variant="danger"
            >
              <feather-icon
                icon="CheckIcon"
                class="mr-25"
              />
              <span> Retour payé </span>
            </b-badge>
          </div>
          <div
            v-if="props.row.status === 28"
          >
            <b-badge
              class="
            badge-glow"
              pill
              variant="success"
            >
              <feather-icon
                icon="CheckCircleIcon"
                class="mr-25"
              />
              <span> Retour payé recu </span>
            </b-badge>
          </div>
          <div
            v-if="props.row.status === 10"
          >
            <b-badge
              class="
            badge-glow"
              pill
              variant="danger"
            >
              <feather-icon
                icon="CheckIcon"
                class="mr-25"
              />
              <span>Retour inter-agence</span>
            </b-badge>
          </div>
          <div
            v-if="props.row.status === 11"
          >
            <b-badge
              class="
            badge-glow"
              pill
              variant="danger"
            >
              <feather-icon
                icon="CheckIcon"
                class="mr-25"
              />
              <span>Retour inter-agence reçu</span>
            </b-badge>
          </div>
          <div
            v-if="props.row.status === 12"
          >
            <b-badge
              class="
            badge-glow"
              pill
              variant="danger"
            >
              <feather-icon
                icon="XIcon"
                class="mr-25"
              />
              <span>Colis annulé par admin</span>
            </b-badge>
          </div>
          <div
            v-if="props.row.status === 13"
          >
            <b-badge
              class="
            badge-glow"
              pill
              variant="danger"
            >
              <feather-icon
                icon="XIcon"
                class="mr-25"
              />
              <span>Colis perdu</span>
            </b-badge>
          </div>
          <div v-if="props.row.status === 14">
            <b-badge
              class="badge-glow"
              pill
              variant="warning"
            >
              <feather-icon
                icon="AlertTriangleIcon"
                class="mr-25"
              />
              <span>À vérifier</span>
            </b-badge>
          </div>
          <div v-if="props.row.status === 19">
            <b-badge
              class="badge-glow bg-success bg-lighten-3"
              pill
            >
              <feather-icon
                icon="CheckIcon"
                class="mr-25"
              />
              <span>Livré Temporaire</span>
            </b-badge>
          </div>
          <div v-if="props.row.status === 20">
            <b-badge
              class="badge-glow bg-warning bg-lighten-3"
              pill
            >
              <feather-icon
                icon="ClockIcon"
                class="mr-25"
              />
              <span>Problème livraison</span>
            </b-badge>
            <div
              v-if="props.row.last_return_reason"
              class="mt-1 small text-warning font-weight-bold"
            >
              <strong>{{ props.row.last_return_reason.return_reason }}</strong>
              <div>
                <!-- Show driver name for temporary return reasons -->
                <div
                  v-if="props.row.last_return_reason.is_temporary && props.row.last_return_reason.driver_name"
                  class="d-flex align-items-center"
                >
                  <feather-icon
                    icon="UserIcon"
                    size="14"
                    class="mr-1"
                  />
                  <span class="font-italic text-dark">Chauffeur :</span>
                  <span class="ml-1">{{ props.row.last_return_reason.driver_name }}</span>
                </div>
                <div
                  v-if="props.row.last_return_reason.scheduled_date"
                  class="d-flex align-items-center"
                >
                  <feather-icon
                    icon="CalendarIcon"
                    size="14"
                    class="mr-1"
                  />
                  <span class="font-italic text-dark">Prévu le :</span>
                  <span class="ml-1">{{ formatDateTime(props.row.last_return_reason.scheduled_date) }}</span>
                </div>
                <div v-if="props.row.last_return_reason.additional_note">
                  <span class="font-italic text-muted">Remarque :</span>
                  <span class="ml-1">{{ props.row.last_return_reason.additional_note }}</span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="props.row.status === 24">
            <b-badge
              class="badge-glow bg-danger"
              pill
            >
              <feather-icon
                icon="AlertTriangleIcon"
                class="mr-25"
              />
              <span>Anomalie de livraison</span>
            </b-badge>
            <div
              v-if="props.row.last_return_reason"
              class="mt-1 small text-danger font-weight-bold"
            >
              <strong>{{ props.row.last_return_reason.return_reason }}</strong>
            </div>
          </div>
          <div v-if="props.row.status === 25">
            <b-badge
              class="badge-glow bg-warning"
              pill
            >
              <feather-icon
                icon="RefreshCwIcon"
                class="mr-25"
              />
              <span>Échange</span>
            </b-badge>
          </div>
          <div v-if="props.row.status === 26">
            <b-badge
              class="badge-glow bg-success"
              pill
            >
              <feather-icon
                icon="CheckCircleIcon"
                class="mr-25"
              />
              <span>Échange reçu</span>
            </b-badge>
          </div>
        </span>
        <span v-else-if="props.column.field === 'phone1'">
          {{ props.row.phone1 }}
          <span v-if="props.row.phone2">-</span>
          {{ props.row.phone2 }}
        </span>
        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <div class="action-icons-container">
            <!-- Printer Icon -->
            <router-link
              v-if="user.role === 'admin' || user.role === 'manager' || ((props.row.status === 0 || props.row.status === 1) && user.role === 'supplier')"
              class="action-icon text-success"
              :to="{ name: 'delivery-note-show', params: { id: props.row.id } }"
            >
              <feather-icon
                :id="`invoice-row-${props.row.id}-showdel-icon`"
                icon="PrinterIcon"
                size="14"
              />
              <b-tooltip
                title="Bordereau"
                :target="`invoice-row-${props.row.id}-showdel-icon`"
              />
            </router-link>

            <!-- Quick View Icon -->
            <span
              :id="`invoice-row-${props.row.id}-quickview-icon`"
              class="action-icon cursor-pointer text-danger"
            >
              <feather-icon
                icon="TargetIcon"
                size="14"
              />
              <b-tooltip
                title="Aperçu rapide"
                :target="`invoice-row-${props.row.id}-quickview-icon`"
              />
            </span>

            <span
              v-if="(user.role ==='admin' && (props.row.status === 0 || props.row.status === 1 || props.row.status === 2 || props.row.status === 3 || props.row.status === 15)) || (user.role === 'manager' && (props.row.status === 0 || props.row.status === 1)) || (user.role === 'supplier' && (props.row.status === 0 || props.row.status === 15))"
              :id="`invoice-row-${props.row.id}-trash-icon`"
              class="action-icon cursor-pointer text-danger"
              @click="deleteOrder(props.row.id)"
            >
              <feather-icon
                icon="TrashIcon"
                size="14"
              />
              <b-tooltip
                title="Supprimer"
                :target="`invoice-row-${props.row.id}-trash-icon`"
              />
            </span>

            <!-- View Details Icon -->
            <router-link
              class="action-icon text-info"
              :to="{ name: 'order-show', params: { id: props.row.id } }"
            >
              <feather-icon
                :id="`invoice-row-${props.row.id}-show-icon`"
                icon="EyeIcon"
                size="14"
              />
              <b-tooltip
                title="Détail"
                :target="`invoice-row-${props.row.id}-show-icon`"
              />
            </router-link>

            <!-- Edit Icon -->
            <router-link
              v-if="user.role === 'admin' || (user.role === 'supplier' && user.id === 86 && (props.row.status === 0 || props.row.status === 1))"
              class="action-icon text-warning"
              :to="{ name: 'order-edit', params: { id: props.row.id } }"
            >
              <feather-icon
                :id="`invoice-row-${props.row.id}-edit-icon`"
                icon="EditIcon"
                size="14"
              />
              <b-tooltip
                title="Modifier"
                :target="`invoice-row-${props.row.id}-edit-icon`"
              />
            </router-link>

            <span
              v-if="props.row.return_number >= 1 || props.row.last_return_reason"
              :id="`invoice-row-${props.row.id}-hist-icon`"
              class="action-icon cursor-pointer text-danger"
              @click="openReturnReasonModal(props.row.id)"
            >
              <feather-icon
                icon="InfoIcon"
                size="14"
              />
              <b-tooltip
                title="Historique de retour"
                :target="`invoice-row-${props.row.id}-hist-icon`"
              />
            </span>
          </div>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">
              Affichage 1 à            </span>
            <b-form-select
              v-model="pageLength"
              :options="['50','100','500']"
              class="mx-1"
              @input="(value) => {
                props.perPageChanged({currentPerPage:value});
                getOrders(1); // Reload first page with new page length
              }"
            />
            <span class="text-nowrap "> de {{ count }} entrées
            </span>
          </div>

          <div>
            <b-pagination
              v-model="currentPage"
              :total-rows="count"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="pageNext(currentPage)"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
          <b-modal
            ref="returnReasonModal"
            title="historique de retour"
          >
            <ul
              v-for="reason in returnDetails"
              :key="reason.content"
            >
              <li>{{ reason.motif_retour }} - {{ reason.created_at }}</li>
            </ul>
          </b-modal>
        </div>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import {
  BPagination, BFormGroup, BFormInput, BButton, BTooltip, BBadge, BSpinner, BFormSelect, BRow, BCol, BModal,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import axios from 'axios'
import storeAuth from '@/store/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import { ValidationProvider } from 'vee-validate'
import QrcodeVue from 'qrcode.vue'
import formatDistance from 'date-fns/formatDistance'
import { fr } from 'date-fns/locale'

export default {
  components: {
    VueGoodTable,
    BPagination,
    BFormGroup,
    BFormInput,
    BTooltip,
    BButton,
    BBadge,
    vSelect,
    ValidationProvider,
    BSpinner,
    BFormSelect,
    QrcodeVue,
    BRow,
    BCol,
    BModal,
  },
  data() {
    return {
      size: 80,
      date: null,
      status: null, // Set to null by default to show all orders
      pageLength: 100,
      rangeDate: null,
      dir: false,
      currentPage: 1,
      count: 0,
      name: '',
      phone: '',
      governorates: [],
      filteredSuppliers: [],
      allSuppliers: [],
      governorate: '',
      columns: [
        {
          label: 'Action',
          field: 'action',
          width: '120px',
          sortable: false,
        },
        {
          label: 'BL',
          field: 'id',
          width: '130px',
        },
        {
          label: 'Code Secret',
          field: 'secret_code',
          width: '132px',
        },
        {
          label: 'Client',
          field: 'name',
        },
        {
          label: 'Fournisseur',
          field: 'supplier.username',
        },
        {
          label: 'Gouvernorat',
          field: 'governorate',
        },
        {
          label: 'Téléphone',
          field: 'phone1',

        },
        {
          label: 'Etat',
          field: 'status',
          width: '110px',
        },
        {
          label: 'Prix TTC',
          field: 'price_ttc',
          width: '110px',
        },
        {
          label: 'N°retour',
          field: 'return_number',
          width: '110px',
        },
        {
          label: 'Date intégration centrale',
          formatFn: this.formatFn,
          field: 'central_hub_received_at',
          width: '130px',
        },
        {
          label: 'Date de Livraison',
          formatFn: value => (value ? this.formatFn(value) : '-'),
          field: 'delivered_at',
          width: '130px',
        },
      ],
      repository: { id: null },
      repositories: [],
      role: '',
      orders: [],
      user: {},
      isLoading: false,
      bl: '',
      awaitingSearch: false,
      supplier1: {
        id: null,
      },
      returnDetails: {},
      showPopup: false,
      isExchange: null,
      isFragile: null,
      exchangeOptions: [
        { value: true, label: 'Échange' },
        { value: false, label: 'Normal' },
      ],
      fragileOptions: [
        { value: true, label: 'Fragile' },
        { value: false, label: 'Non fragile' },
      ],
      isSynchronized: null,
      outsourcingCompany: { id: null },
      outsourcingCompanies: [],
      syncOptions: [
        { value: true, label: 'Synchronisé' },
        { value: false, label: 'Non synchronisé' },
      ],
    }
  },
  created() {
    this.user = storeAuth.state.user

    // Add "Synchronisé par" column only if user is admin
    if (this.user.role === 'admin') {
      this.columns.push({
        label: 'Synchronisé avec',
        field: 'outsourcing_company',
        width: '130px',
      })
    }

    // Always call getOrders to load data
    this.getOrders(1)
    if (this.user.role === 'admin') {
      this.getRepositories()
      this.getAllSuppliers()
    }
    if (this.user.role === 'manager') {
      this.getAllSuppliers()
    }
    this.getGovernorates()
    if (this.user.role === 'admin') {
      this.getOutsourcingCompanies()
    }
  },

  methods: {
    async openReturnReasonModal(orderId) {
      const response = await axios.get(`/api/orders/${orderId}/return-details/`)
      const returnDetails = response.data
      // Assuming you have a state variable to store the return details
      this.returnDetails = returnDetails
      this.$refs.returnReasonModal.show()
    },
    clearGovernorate() {
      this.governorate = ''
      // Always use getOrders to preserve all other filters
      this.getOrders(1)
    },
    clearSupplier() {
      this.supplier1 = { id: null }
      // Always use getOrders to preserve all other filters
      this.getOrders(1)
    },
    clearExchange() {
      this.isExchange = null
      this.getOrders(1)
    },
    clearFragile() {
      this.isFragile = null
      this.getOrders(1)
    },
    clearSynchronized() {
      this.isSynchronized = null
      this.getOrders(1)
    },
    clearOutsourcingCompany() {
      this.outsourcingCompany = { id: null }
      this.getOrders(1)
    },
    async filterByExchange() {
      this.isLoading = true
      // Don't reset other filters - preserve them
      try {
        const params = {
          is_exchange: this.isExchange?.value,
          status: this.status,
          repository: this.repository.id,
          governorate: this.governorate.id,
          supplier: this.supplier1.id,
          is_fragile: this.isFragile?.value,
          is_synchronized: this.isSynchronized?.value,
          outsourcing_company: this.outsourcingCompany?.id,
          // Preserve text search filters
          name: this.name,
          bl: this.bl,
          phone: this.phone,
          p: 1,
          page_size: this.pageLength,
        }
        const { data } = await axios.get('/api/orders/list/', { params })
        this.orders = data.results
        this.count = data.count
        this.currentPage = 1
      } catch (error) {
        this.showToast('danger', 'top-center', 'Error filtering by exchange type')
      } finally {
        this.isLoading = false
      }
    },
    async filterByFragile() {
      this.isLoading = true
      // Don't reset other filters - preserve them
      try {
        const params = {
          is_fragile: this.isFragile?.value,
          status: this.status,
          repository: this.repository.id,
          governorate: this.governorate.id,
          supplier: this.supplier1.id,
          is_exchange: this.isExchange?.value,
          is_synchronized: this.isSynchronized?.value,
          outsourcing_company: this.outsourcingCompany?.id,
          // Preserve text search filters
          name: this.name,
          bl: this.bl,
          phone: this.phone,
          p: 1,
          page_size: this.pageLength,
        }
        const { data } = await axios.get('/api/orders/list/', { params })
        this.orders = data.results
        this.count = data.count
        this.currentPage = 1
      } catch (error) {
        this.showToast('danger', 'top-center', 'Error filtering by fragile status')
      } finally {
        this.isLoading = false
      }
    },
    clearDepot() {
      this.repository = {}
      this.getOrders(1)
    },
    async getGovernorates() {
      const { data } = await axios.get('/api/governorates/')
      this.governorates = data
    },
    async pageNext(currentPage) {
      // Check if searching by name
      if (this.name.length >= 1) {
        this.currentPage = currentPage
        await this.findByName()
      } else if (this.phone.length >= 2) {
        this.currentPage = currentPage
        await this.findByPhone()
      } else {
        this.getOrders(currentPage)
      }
    },
    async findById() {
      // Don't reset other text filters - only search by BL
      if (this.bl.length >= 1) {
        this.isLoading = true
        try {
          // Use the unified filter endpoint instead of the removed search-by-bl endpoint
          const { data } = await axios.get('/api/orders/list/', {
            params: {
              id: this.bl,
              p: this.currentPage,
              page_size: this.pageLength,
            },
          })
          this.orders = data.results
          this.count = data.count
          this.totalPages = data.total_pages
          this.currentPageNumber = data.page_number
        } catch (error) {
          this.showToast('danger', 'top-center', 'Error searching by ID')
        } finally {
          this.isLoading = false
        }
      } else {
        this.getOrders(1)
      }
    },
    async findByName() {
      // Don't reset other text filters - only search by name
      if (this.name.length >= 1) {
        this.isLoading = true
        try {
          // Use the unified filter endpoint instead of the removed search-by-name endpoint
          const { data } = await axios.get('/api/orders/list/', {
            params: {
              name: this.name,
              p: this.currentPage,
              page_size: this.pageLength,
            },
          })
          this.orders = data.results
          this.count = data.count
          this.totalPages = data.total_pages
          this.currentPageNumber = data.page_number
          this.isLoading = false
        } catch (error) {
          this.showToast('danger', 'top-center', 'Error searching by name')
          this.isLoading = false
        }
      } else if (this.name.length === 0) {
        this.getOrders(1)
      }
    },
    async findByPhone() {
      // Don't reset other text filters - only search by phone
      if (this.phone.length >= 2) {
        this.isLoading = true
        try {
          // Use the unified filter endpoint instead of the removed search-by-phone endpoint
          const { data } = await axios.get('/api/orders/list/', {
            params: {
              phone: this.phone,
              p: this.currentPage,
              page_size: this.pageLength,
            },
          })
          this.orders = data.results
          this.count = data.count
          this.totalPages = data.total_pages
          this.currentPageNumber = data.page_number
        } catch (error) {
          this.showToast('danger', 'top-center', 'Error searching by phone')
        } finally {
          this.isLoading = false
        }
      } else if (this.phone.length === 0) {
        this.getOrders(1)
      }
    },
    async getAllSuppliers() {
      try {
        const { data } = await axios.get('api/auth/users/suppliers/')
        this.allSuppliers = Array.isArray(data) ? data : []
        this.filteredSuppliers = this.allSuppliers
      } catch (error) {
        this.showToast('danger', 'top-center', 'Error fetching suppliers')
      }
    },
    async findByGovernorate(currentPage) {
      this.isLoading = true
      this.pageLength = 100
      // Don't reset text search filters - preserve them
      try {
        const params = {
          governorate: this.governorate.id,
          status: this.status,
          repository: this.repository.id,
          p: currentPage,
          supplier: this.supplier1.id,
          page_size: this.pageLength,
          is_exchange: this.isExchange?.value,
          is_fragile: this.isFragile?.value,
          is_synchronized: this.isSynchronized?.value,
          outsourcing_company: this.outsourcingCompany?.id,
          // Preserve text search filters
          name: this.name,
          bl: this.bl,
          phone: this.phone,
        }
        const { data } = await axios.get('/api/orders/list/', { params })
        this.orders = data.results
        this.count = data.count
      } catch (error) {
        this.showToast('danger', 'top-center', 'Error searching by governorate')
      } finally {
        this.isLoading = false
      }
    },

    async findBySupplier(currentPage) {
      this.isLoading = true
      this.pageLength = 100
      // Don't reset text search filters - preserve them
      try {
        const params = {
          supplier: this.supplier1.id,
          status: this.status,
          repository: this.repository.id,
          governorate: this.governorate.id,
          p: currentPage,
          page_size: this.pageLength,
          is_exchange: this.isExchange?.value,
          is_fragile: this.isFragile?.value,
          is_synchronized: this.isSynchronized?.value,
          outsourcing_company: this.outsourcingCompany?.id,
          // Preserve text search filters
          name: this.name,
          bl: this.bl,
          phone: this.phone,
        }
        const { data } = await axios.get('/api/orders/list/', { params })
        this.orders = data.results
        this.count = data.count
      } catch (error) {
        this.showToast('danger', 'top-center', 'Error searching by supplier')
      } finally {
        this.isLoading = false
      }
    },

    async getRepositories() {
      try {
        const { data } = await axios.get('/api/repositories/')
        this.repositories = data
      } catch (error) {
        this.showToast('danger', 'top-center', 'Error fetching repositories')
      }
    },
    async getOutsourcingCompanies() {
      try {
        const { data } = await axios.get('/api/companies/outsourcing-company/')
        this.outsourcingCompanies = data
      } catch (error) {
        this.showToast('danger', 'top-center', 'Error fetching outsourcing companies')
      }
    },
    formatFn(value) {
      return formatDistance(new Date(value), new Date(), { addSuffix: true, locale: fr })
    },
    async getOrders(currentPage) {
      // Ensure the pageLength is used consistently
      this.searchTerm = ''

      try {
        this.isLoading = true
        const params = {
          page_size: this.pageLength,
          p: currentPage,
          supplier: this.supplier1.id,
          repository: this.repository.id,
          status: this.status,
          governorate: this.governorate.id,
          is_exchange: this.isExchange?.value,
          is_fragile: this.isFragile?.value,
          is_synchronized: this.isSynchronized?.value,
          outsourcing_company: this.outsourcingCompany?.id,
          // Include text search filters to preserve them
          name: this.name,
          bl: this.bl,
          phone: this.phone,
        }

        const { data } = await axios.get('/api/orders/list/', {
          params,
        })
        this.count = data.count
        this.orders = data.results
        this.isLoading = false
      } catch (error) {
        setTimeout(() => {
          this.showToast('danger', 'top-center', error.toString())
        }, 1000)
      }
    },
    showToast(variant, position, text) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'Notification',
            icon: 'InfoIcon',
            text,
            variant,
          },
        },
        {
          position,
        },
      )
    },
    async deleteOrder(id) {
      try {
        const result = await this.$swal({
          title: 'Vous êtes sûr?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'oui je veux supprimer ! ',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        })
        this.isLoading = true
        if (result.value) {
          try {
            await axios.delete(`/api/orders/delete/${encodeURIComponent(id)}/`)
            this.isLoading = false
            await this.getOrders()
            setTimeout(() => {
              this.showToast('success', 'top-center', 'colis supprimé avec succés')
            }, 1000)
          } catch (error) {
            this.isLoading = false
            setTimeout(() => {
              this.showToast('danger', 'top-center', error.toString())
            }, 1000)
          }
        } else if (result.dismiss === 'cancel') {
          this.isLoading = false
          await this.$swal({
            title: 'Fermer',
            text: 'colis Non Supprimée :)',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      } catch (e) {
        // handle error if needed
      }
    },
    /**
     * Format date for display
     */
    formatDateTime(dateString) {
      if (!dateString) return '-'

      try {
        const date = new Date(dateString)
        return date.toLocaleString('fr-FR', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
        })
      } catch (error) {
        return dateString
      }
    },
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import '@core/scss/vue/libs/vue-good-table.scss';

// Action icons container styles - organized grid layout
.action-icons-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
  padding: 4px 0;
  justify-items: center;
  align-items: center;
  width: 100%;
}

.action-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.action-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  transition: all 0.15s ease;

  &:hover {
    transform: scale(1.15);
    opacity: 0.85;
  }
}

.action-icon-placeholder {
  display: inline-block;
  width: 24px;
  height: 24px;
}
</style>
